export const initialState = {
  activeEvents: {},
  rejectedEvents: {},
  completedEvents: {},
  calls: {},
  initialized: false,
  loading: false,
  error: false,
};
